import { InjectionToken, inject } from '@angular/core';
import { OpenFirestoreClient, injectFirestoreClient } from '@open/ngx-firebase/firestore';

export type ListOfCollections =
  | 'BUSINESS_USERS'
  | 'VALIDATED_MASKS'
  | 'AGENCIES'
  | 'AGENCY_ADMINS'
  | 'BENEFICIARIES'
  | 'COMPANIES'
  | 'EMAIL_EVENTS'
  | 'INVOICES'
  | 'ORDERS'
  | 'PAYBACKS'
  | 'PINS'
  | 'PROVISIONS'
  | 'USERS'
  | 'VAT'
  | 'OPEN_BANKING_BANKS'
  | 'SCAN_TRANSACTIONS_TEST'
  | 'APP_AVAILABILITY'
  | 'OPEN_BANKING_TOKENS'
  | 'COUNTERS'
  | 'PUBLIC_HOLIDAYS'
  | 'BUSINESSES'
  | 'BUSINESS_ADMINS'
  | 'BUSINESS_CASHIER'
  | 'COUNTRY_FLAGS'
  | 'STATEMENTS'
  | 'PAYMENT_TRANSACTIONS'
  | 'YEARLY_MILLESIME_METADATA'
  | 'CONTRACT_BASED_MILLESIME_METADATA'
  | 'MILLESIME_REPORTS'
  | 'OPEN_BANKING_SYNC_STATUS'
  | 'ANALYTICS'
  ;

export type BusinessDb = OpenFirestoreClient<ListOfCollections>;

// Token-backed so specs can `{ provide: BUSINESS_DB, useValue: stub }`.
export const BUSINESS_DB: InjectionToken<BusinessDb> = new InjectionToken<BusinessDb>('BUSINESS_DB', {
  providedIn: 'root',
  factory: (): BusinessDb => injectFirestoreClient<ListOfCollections>(),
});

export function injectDb(): BusinessDb {
  return inject(BUSINESS_DB);
}
